export default __webpack_public_path__ + "static/media/imagen_video.14b5e5b7.png";